import { useMutation } from '@tanstack/vue-query'
import { useUsersApi } from './use-users'

export function useUpdateUserKcProfile() {
  const { updateUserKcProfile } = useUsersApi()

  return useMutation({
    mutationFn: (kcProfile) => updateUserKcProfile(kcProfile),
    onError: async (error) => {
      console.log('error', error)
    },
  })
}
